import container from '@ioc';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IAuthenticationService$ } from '@services/auth/IAuthentication.interface';
import { ILoggingService$ } from '@services/logging/ILoggingService.interface';
import appConfig from '@src/app/config/appConfig';
import { DocumentSummary, IAuthenticationService, ILoggingService, ClientAccountsServiceClient } from 'clientportalshared';
import { documentsApiThunkPayload } from '../../constants';
import { DocumentsRequest } from './types';

export const getDocumentsAsync = createAsyncThunk<DocumentSummary[], DocumentsRequest>(
  documentsApiThunkPayload,
  async (payload: DocumentsRequest) => {
    const authService = container.get<IAuthenticationService>(IAuthenticationService$);
    const loggingService = container.get<ILoggingService>(ILoggingService$);

    const clientAccountsClient = new ClientAccountsServiceClient(appConfig.apiEndpointUrl, authService, loggingService, appConfig);
    const filteredClientAccounts = payload.clientAccounts.filter((account) => {
      return account.portfolios?.findIndex((portfolio) => portfolio.portfolioKey && payload.portfolioKeys.includes(portfolio.portfolioKey)) !== -1;
    });

    const documentPromises = filteredClientAccounts.map((clientAccount) => {
      if (!clientAccount.clientAccountKey) {
        return [];
      }
      return clientAccountsClient.getAllDocumentsAsync(clientAccount.clientAccountKey, null, null);
    });

    const documentResults = await Promise.all(documentPromises);
    const documentKeys: string[] = [];

    const uniqueDocuments: DocumentSummary[] = [];

    for (const documentArray of documentResults) {
      for (const document of documentArray) {
        if (!document.documentKey || documentKeys.includes(document.documentKey)) {
          continue;
        }
        uniqueDocuments.push(document);
        documentKeys.push(document.documentKey);
      }
    }

    return uniqueDocuments;
  }
);
